import React from "react";
import ReactMarkdown from "react-markdown";

const FormLayout = ({ bgColor = "#090D24", data, children }) => {
  return (
    <div
      className="container-fluid p-0 m-0 p-5"
      style={{ background: bgColor }}
    >
      <div className="row  p-5">
        <div className="col-12">
          <span className="text-white fs-5 fw-semibold">
            {data?.page_title}
          </span>
        </div>
      </div>

      <div className="row justify-content-center px-md-5 gy-5">
        <div className="col-md-6 ">
          <div className="row gap-5">
            <div className="col-12">
              <div className="d-flex flex-column gap-4 w-75">
                <h1 className="display-3 text-white fw-bolder">
                  {data?.heading}
                </h1>
              </div>
            </div>

            <div className="col-12">
              <div className="d-flex flex-column gap-4 text-white fw-semibold">
                <div className="d-flex flex-column">
                  <MarkdownComponent markdown={data?.description} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Custom Form Items */}
        <div className="col-md-6">
          <form>
            <div className="row gx-3 gy-4">{children}</div>
          </form>
        </div>
      </div>
    </div>
  );
};

export const MarkdownComponent = ({
  markdown,
  imgwidth,
  imgheight,
  markdowncss,
}) => {
  return (
    // <ReactMarkdown className="w-100 markdown-container ">
    //   {markdown}
    // </ReactMarkdown>
    <div
      style={{ maxWidth: "100%", overflowX: "hidden", textAlign: "justify" }}
    >
      <ReactMarkdown
        components={{
          img: ({ node, ...props }) => (
            <div className={markdowncss}>
              <img
                {...props}
                style={{
                  maxWidth: imgwidth === "" ? "100%" : imgwidth,
                  height: imgheight === "" ? "auto" : imgheight,
                }}
                alt={props.alt}
              />
            </div>
          ),
        }}
      >
        {markdown}
      </ReactMarkdown>
    </div>
  );
};

export default FormLayout;
